import FJModalClose from '../FJModalClose/FJModalClose';
import styles from './FJUpgradesTips.module.less';
import FJCredits from '../../../assets/svg/credits.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJCoinSVG from '../../../assets/base64/cion-new.js';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant.js';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';

const FJUpgradesTips = ({ title, content, buttonText, onClose, onUpgrade, buttonType, onClick }) => {
    const _renderBtn = () => {
        if (buttonType === FJConstant.SUBMIT) {
            return <FJButton className={styles.sub_btn} text='got-it' type='gradient' onClick={onClick} />;
        }
        return (
            <div className={styles.button} onClick={onUpgrade}>
                <img className={styles.coin_img} src={FJCoinSVG} alt='coin' />
                {FJLocalStore._(buttonText)}
            </div>
        );
    };

    return (
        <div className={styles.container}>
            <FJModalClose onClick={onClose} />

            <FJCredits />

            <div className={styles.title}>{FJLocalStore._(title)}</div>
            <div className={styles.content}>{FJLocalStore._(content)}</div>

            {_renderBtn()}
        </div>
    );
};

FJUpgradesTips.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    buttonText: PropTypes.string,
    onClose: PropTypes.func,
    onUpgrade: PropTypes.func,
    buttonType: PropTypes.string,
    onClick: PropTypes.func,
};

export default FJUpgradesTips;
